<template>
  <div>
    <h1 class="flex mb-8 font-bold text-3xl">
      <icon name="filter" class="w-6 mr-3 fill-gray-700" /> Filtros
    </h1>

    <div class="mb-6 flex justify-between items-center">
      <!-- Text input para pesquisa -->
      <text-input
        v-model="searchTerm"
        label="Pesquisar"
        class="w-full max-w-md mr-4"
        placeholder="Buscar..."
      />

      <!-- Botão para criar filtro -->
      <inertia-link class="btn-indigo" :href="route('social.create')">
        <span>Criar filtro</span>
      </inertia-link>
    </div>

    <!-- Tabela de resultados -->
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">Título</th>
          <th class="px-6 pt-6 pb-4">Valores</th>
          <th class="px-6 pt-6 pb-4">Perfil</th>
          <th class="px-6 pt-6 pb-4">Vigente</th>
          <th class="px-6 pt-6 pb-4">Ações</th>
        </tr>

        <!-- Renderização dos resultados -->
        <template v-if="filteredResearchs.length">
          <tr
            v-for="research in filteredResearchs"
            :key="research.id"
            class="hover:bg-gray-100 focus-within:bg-gray-100"
          >
            <td class="border-t">
              <inertia-link
                class="px-6 py-4 flex items-center"
                :href="route('social.edit', research.id)"
                tabindex="-1"
              >
                {{ research.label }}
              </inertia-link>
            </td>
            <td class="border-t">
              <inertia-link
                class="px-6 py-4 flex items-center"
                :href="route('social.edit', research.id)"
                tabindex="-1"
              >
                {{ formatValues(research.values) }}
              </inertia-link>
            </td>
            <td class="border-t">
              <inertia-link
                class="px-6 py-4 flex items-center"
                :href="route('social.edit', research.id)"
                tabindex="-1"
              >
                {{ research.role }}
              </inertia-link>
            </td>
            <td class="border-t">
              <inertia-link
                class="px-6 py-4 flex items-center"
                :href="route('social.edit', research.id)"
                tabindex="-1"
              >
                <div
                  v-if="research.current === 'Sim'"
                  style="
                    display: flex;
                    padding: 4px;
                    border-radius: 8px;
                    padding: 8px;
                    border: 1px solid #4ed14e4d;
                    background: #4ed14e4d;
                    font-weight: 600;
                    color: #087d08;
                  "
                >
                  {{ research.current }}
                </div>
                <div
                  v-if="research.current === 'Não'"
                  style="
                    display: flex;
                    padding: 4px;
                    border-radius: 8px;
                    padding: 8px;
                    border: 1px solid #f25362;
                    background: #f25362;
                    font-weight: 600;
                    color: #fff;
                  "
                >
                  {{ research.current }}
                </div>
              </inertia-link>
            </td>
            <td class="border-t flex items-center">
              <button class="px-3 py-2 flex items-center mr-2" @click="confirmDelete(research.id)">
                <font-awesome-icon :icon="['fas', 'trash-alt']" />
              </button>
              <inertia-link
                class="px-3 py-2 flex items-center"
                :href="route('social.edit', research.id)"
                tabindex="-1"
              >
                <font-awesome-icon :icon="['fas', 'edit']" />
              </inertia-link>
            </td>
          </tr>
        </template>

        <template v-else>
          <tr>
            <td colspan="5" class="text-center py-4">Nenhum resultado encontrado.</td>
          </tr>
        </template>
      </table>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Layout from '../Components/Layout/Layout.vue'
import Icon from '@/Shared/Icon'
import TextInput from '@/Shared/TextInput'

export default {
  components: {
    Icon,
    TextInput,
  },
  layout: Layout,
  props: {
    researchs: Array,
  },
  data() {
    return {
      searchTerm: '',
    }
  },
  computed: {
    filteredResearchs() {
      const term = this.searchTerm.toLowerCase()
      return this.researchs.filter(
        (research) =>
          research.label.toLowerCase().includes(term) ||
          this.formatValues(research.values).toLowerCase().includes(term) ||
          research.role.toLowerCase().includes(term) ||
          research.current.toString().toLowerCase().includes(term),
      )
    },
  },
  methods: {
    confirmDelete(id) {
      if (confirm('Tem certeza de que deseja excluir este filtro?')) {
        this.deleteResearch(id)
      }
    },
    deleteResearch(id) {
      // eslint-disable-next-line vue/no-mutating-props
      try {
        const response = axios.delete(`/api/social-media/term/${id}`)
        this.researchs = this.researchs.filter((research) => research.id !== id)
      } catch (error) {
        console.log('deleteResearch error: ', error)
      }
    },
    formatValues(values) {
      if (!values) {
        return ''
      }
      return values.map((data) => data.value).join('; ')
    },
  },
}
</script>
